<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/3">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-danger mb-4"
                style="background: rgba(var(--vs-danger),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{totals.total | money}}</h2>
                <span>Devoluções do Período</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <div id="data-list-list-view" class="data-list-container mt-5">
      <div class="flex mb-4 px-2">
        <div class="flex-1 px-2">
          <vs-input class="w-100 inputx" placeholder="Número" v-model="filters.number" />
        </div>
        <div class="flex-1 px-2">
          <vs-input class="w-100 inputx" placeholder="E-mail" v-model="filters.email" />
        </div>
        <div class="flex-1 px-2">
          <Datepicker
            :language="ptBR"
            :clear-button="true"
            placeholder="Data Inicial"
            :use-utc="true"
            format="dd/MM/yyyy"
            v-model="filters.created_at.start"
          />
        </div>
        <div class="flex-1 px-2">
          <Datepicker
            :language="ptBR"
            :clear-button="true"
            placeholder="Data Final"
            :use-utc="true"
            format="dd/MM/yyyy"
            v-model="filters.created_at.end" />
        </div>
      </div>

      <div class="flex justify-center">
        <div>
          <vs-pagination :max="10" :total="refunds.last_page" v-model="refunds.current_page"></vs-pagination>
        </div>
      </div>

      <vs-table
        ref="table"
        noDataText="Nenhum item encontrado no período selecionado"
        :data="data"
        :sst="true"
        :stripe="true"
      >
        <template slot="thead">
          <vs-th>DATA/HORA</vs-th>
          <vs-th>VENDA</vs-th>
          <vs-th>EMAIL</vs-th>
          <vs-th>VALOR</vs-th>
          <vs-th>FORMA</vs-th>
          <vs-th>COMENTÁRIO</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
            <vs-td :data="data[idx].created_at">{{data[idx].created_at | formatDateTime}}</vs-td>
            <vs-td v-if="data[idx].order">
              <router-link :to="{ name: 'venda-detalhes', params: { id: data[idx].order.id } }">{{data[idx].order.number}}</router-link>
            </vs-td>
            <vs-td v-else>
              <router-link :to="{ name: 'venda-detalhes', params: { id: data[idx].order_id } }">{{data[idx].order_id}}</router-link>
            </vs-td>
            <vs-td v-if="data[idx].order && data[idx].order.user">
              <router-link
                :to="{ name: 'cliente-detalhes', params: { id: data[idx].order.user.id } }"
              >{{data[idx].order.user.email}}</router-link>
            </vs-td>
            <vs-td v-else>-</vs-td>
            <vs-td :data="data[idx].amount">{{data[idx].amount | money}}</vs-td>
            <vs-td>{{data[idx].refund_method}}</vs-td>
            <vs-td>{{data[idx].comment}}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div class="flex justify-center">
        <div>
          <vs-pagination :max="10" :total="refunds.last_page" v-model="refunds.current_page"></vs-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import { ptBR } from 'vuejs-datepicker/dist/locale';

export default {
  components: {
    'v-select': vSelect,
    Datepicker
  },
  data() {
    return {
      ptBR,
      refunds: {
        current_page: 1,
        last_page: 1
      },
      filters: {
        created_at: {
          start: null,
          end: null
        },
      },
      data: [],
      totals: {
        total: 0,
        refunds: 0,
        avg: 0
      },
      timeout: null
    };
  },

  mounted() {
    const filters = JSON.parse(
      localStorage.getItem(`filters-${this.$route.fullPath}`)
    );

    if (filters) {
      this.filters = filters;
    }

    const query = this.$route.query;
    if (query.payment_method) {
      this.filters.payment_method.selected = [query.payment_method];
    }

    if (query.status) {
      this.filters.status.selected = [query.status];
    }

    if (query['created_at.start'] && query['created_at.end']) {
      this.filters.created_at.start = query['created_at.start'];
      this.filters.created_at.end = query['created_at.end'];
    } else if (!this.filters.created_at.start) {
      this.filters.created_at.start = new Date();
      this.filters.created_at.end = new Date();
    }

    this.load();
  },

  methods: {
    load() {
      this.$vs.loading();

      localStorage.setItem(
        `filters-${this.$route.fullPath}`,
        JSON.stringify(this.filters)
      );

      this.$api
        .get('/api/v1/backend/refunds', {
          params: {
            page: this.refunds.current_page,
            filters: this.filters
          }
        })
        .then(response => {
          this.$vs.loading.close();
          this.data = response.data.refunds.data;
          this.refunds = response.data.refunds;
          this.totals = response.data.totals;
        });
    }
  },

  watch: {
    filters: {
      handler() {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.load();
        }, 600);
      },
      deep: true
    },
    'refunds.current_page'() {
      this.load();
    }
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          bg-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
